import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../actions'
import PageHeader from './page-header'
import Loader from './loader'

class ProvideDetails extends Component {
  constructor(props) {
    super(props)
  }
  componentWillMount() {
    this.props.initialize(this.props.user)
  }
  render() {
    const { loading, handleSubmit, pristine, submitting, postDetails, invalid } = this.props

    return  (
      <div>
        <PageHeader title={"Provide Details"}/>
        <div className='container'>
          <form onSubmit={handleSubmit(postDetails)}>
            <div className="form-group">
              <label>ID Number</label>
              <Field component='input' value={this.props.user.sub} type='text' name="sub" className="form-control" readOnly/>
            </div>
            <div className="form-group">
              <label>Cellphone Number</label>
              <Field component='input' value={this.props.user.cellnumber} type="text" name="cellnumber" className="form-control" readOnly/>
            </div>
            <div className="form-group">
              <label>Email</label>
              <Field
                component='input'
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter your email address..."
                required
                autoFocus={true}
              />
            </div>
            <button
              disabled={loading || pristine || invalid}
              className="btn btn-block btn-success">
                { loading ? <Loader /> : 'Sign In' }
            </button>
          </form>
        </div>
      </div>
    )
  }
}

function mapStateToProps({user, loading, redirecting}, ownProps) {
  return {
    user: user.user,
    loading: loading || redirecting,
    ...ownProps
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    postDetails: bindActionCreators(actions.postDetails, dispatch)
  })
}

ProvideDetails = reduxForm({
  form: 'details'
})(connect(mapStateToProps, mapDispatchToProps)(ProvideDetails))

export default ProvideDetails



// WEBPACK FOOTER //
// ./src/app/components/provide-details.js